interface Metric {
  label: string;
  value: string;
  hint?: string;
}

const PLACEHOLDER_METRICS: Metric[] = [
  { label: "Active servers", value: "0", hint: "Provisioned through the control API" },
  { label: "Active subscribers", value: "0", hint: "Realtime connection count" },
  { label: "Subspaces in use", value: "0", hint: "Spatial subspaces across servers" },
  { label: "State operations / 24h", value: "0", hint: "Persistent state reads and writes" },
  { label: "Inference calls / 24h", value: "0", hint: "Model invocations" },
];

/**
 * Usage tiles. Values are placeholders — analytics are intentionally not
 * fabricated, so numbers render as zero until real telemetry exists.
 */
export function UsagePanel() {
  return (
    <div className="metric-grid">
      {PLACEHOLDER_METRICS.map((metric) => (
        <div className="metric-tile" key={metric.label}>
          <p className="metric-label">{metric.label}</p>
          <p className="metric-value">{metric.value}</p>
          {metric.hint ? <p className="metric-hint">{metric.hint}</p> : null}
        </div>
      ))}
    </div>
  );
}
